import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateSchuelerDummy } from "../../actions/schueler";
import Spinner from "../../components/Spinner";
import Calculations from "../../helpers/calculations";
import FormValidation from "../Validation/FormValidation";
import SchuelerFormFields from "./SchuelerFormFields";
import SchuelerSchema from "./SchuelerSchema";
import { handleSaveProject } from "../../helpers/saveProject";

const SchuelerEdit = ({ setView, activeId }) => {
  const [showFieldErrors, setShowFieldErrors] = useState(false);
  const [variables, setVariables] = useState({});
  const [fieldSettings, setFieldSettings] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const currentUser = useSelector((st) => st.currentUser);
  const currentKlausur = useSelector((st) => st.currentKlausur);
  const companies = useSelector((st) => st.companies);
  const schuelerlist = useSelector((st) => st.schueler);
  const schueler = schuelerlist.find((s) => s.id === activeId);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetch = async () => {
      const schema = new SchuelerSchema(currentKlausur);
      const fields = schema.getFields(companies, currentKlausur);
      setFieldSettings({ ...fields });
      setVariables({ ...schueler });
      (() => setIsLoading(false))();
    };
    if (isLoading) fetch();
  });

  if (isLoading) return <Spinner />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    // dateFormats();

    const calculations = new Calculations(variables, currentKlausur);
    const land = companies.find(
      (c) => c.id === parseInt(currentKlausur.companyId)
    )?.land;
    const gesamtnote = calculations.results[land]?.gesamtnote;
    const formValidation = new FormValidation({
      fieldSettings,
      variables,
      setFieldErrors,
    });
    console.log({ formValidation });
    if (!formValidation.valid) {
      setShowFieldErrors(true);
      setTimeout(() => setShowFieldErrors(false), 3000);
      return;
    }
    const data = {
      ...schueler,
      ...variables,
      updatedAt: new Date().toISOString(),
      updatedBy: currentUser.username,
      gesamtnote,
      entwurf: false,
    };

    dispatch(updateSchuelerDummy(data));
    await handleSaveProject(currentKlausur, companies, [
      ...schuelerlist.filter((s) => s.id !== activeId),
      data,
    ]);
    setView("details");
  };

  const handleSaveEntwurf = async (e) => {
    e.preventDefault();
    const data = {
      ...schueler,
      ...variables,
      updatedAt: new Date().toISOString(),
      updatedBy: currentUser.username,
      entwurf: true,
    };
    dispatch(updateSchuelerDummy(data));
    await handleSaveProject(currentKlausur, companies, [
      ...schuelerlist.filter((s) => s.id !== activeId),
      data,
    ]);
    setView("buttons");
  };
  const props = {
    fieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
    setServerError,
    handleSubmit,
    handleSaveEntwurf,
    setView,
    showFieldErrors,
  };

  return <SchuelerFormFields props={props} />;
};
export default SchuelerEdit;
